<template>
    <div>
        <div v-if="panel_required">
            <div class="form-group mt-3" :data-designer-component-id="component_id">
              <template v-if="label === ''">
                Please enter the RAL/BS colour number you require for your {{ title }}:
              </template>
              <template v-else>
                {{ label }}
              </template>
                <input type="text" v-model="localTarget" id="ral_code" class="form-control">
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        emits: ['update:target'],
        props: {
            title: {
                default(){
                    return '';
                }
            },
            component_id: {
                default(){
                    return 'ral';
                }
            },
            colourId: {
                required: true,
            },
            fabricator: {
                required: true,
            },
            target: {
                default: ''
            },
           label: {
              default: '',
           },
          numbers_only: {
              default(){
                  return false;
              }
          },
        },
        data(){
            return {
                options: {
                    has_ral_option: false,
                },
                fetchData: window._.debounce(function() {
                    window.axios.post('/api/get-ral-text-options', {
                        colour_id: this.colourId,
                    })
                        .then((response) => {
                            this.options = response.data;
                        });
                }, 750)
            }
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.colourId);
            },
            url(){
                //return '/api/options/' + this.fabricator + '/ral-text?colour_id=' + this.colourId;
            },
            cache_key(){
                return '_' + this.colourId;
            },
            panel_required(){
                return this.options.has_ral_option != false;
            },
            localTarget: {
                get() {
                    return this.target;
                },
                set(val) {
                    if (this.target !== val) {
                        this.$emit('update:target', val);
                    }
                }
            }
        },
        watch: {
            'colourId': function (val, oldVal) {
                this.fetchData();
            },
            'localTarget': {
              handler: window._.debounce(function () {
                if(this.numbers_only) {
                    this.localTarget = this.localTarget.replace(/[^0-9]+/g,"");
                } else {
                    this.localTarget = this.localTarget.replace(/[^a-zA-Z0-9]+/g, '');
                }
                if (this.localTarget.length >= 10) {
                  this.localTarget = this.localTarget.substring(0, 10);
                }
              }, 50),
            },
        },
        mounted(){
            this.fetchData();
        },
    }
</script>
